import { getList, getRegionInfo } from '../api';
import { queryOptions } from '@tanstack/react-query';
import { Search } from '../schemas/search';


interface SearchQueryType {
    key?: string
    search: Search
    enabled?: boolean
}

export function searchQueryOptions({ key, search, enabled = true }: SearchQueryType) {
    return queryOptions({
        queryKey: [key, search],
        queryFn: () => getList(search),
        // staleTime: 10 * 1000,
        enabled,
    })
}

export function regionInfoQueryOptions({ key, search, enabled = true }: SearchQueryType) {
    return queryOptions({
        queryKey: [key, search],
        queryFn: () => getRegionInfo(search),
        enabled,
    })
}